<template>
  <b-card
    tag="b-link"
    :to="item.targetUrl"
    :img-src="fileUrl(this.getImage(item.imageUrl))"
    :img-alt="item.title"
    img-top
    class="ml-5 component-product-card card-style d-flex flex-column align-items-stretch game text-dark border-0"
    no-body
  >
    <div class="text-align-center text-center d-flex flex-column justify-content-between p-md-2 p-xxs-1 flex-grow-1">
      <strong v-text="item.title" />
      <small class="d-flex flex-row-reverse text-muted" v-text="item.genre" />
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import windowSize from '@/mixins/window-size'

export default {
  name: 'GameCardOrangeTheme',
  mixins: [windowSize],
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isImageLoaded: false
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl',
    })
  },
  methods: {
    getImage (src) {
      var size = this.isMaxWidth768() ? '?w=170' : '?w=280'
      var result = src + size
      return result
    },
    loaded () {
      this.isImageLoaded = true
    },
  }
}
</script>
